import { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "../components/Button/Button";
import { ApiRequest } from "../api/Api";
import { WalletBalance } from "../components/Logs/WalletBalance";
import { TotalBalance } from "../components/Logs/TotalBalance";

export const Logs = () => {
	const [selectInput, setSelectInput] = useState("address");
	const [searchInput, setSearchInput] = useState("");
	const [walletsBalance, setWalletsBalance] = useState();
	const [total, setTotal] = useState();

	const OnSearchHandler = async () => {};

	useEffect(() => {
		const GetCommonLogs = async () => {
			const response = await ApiRequest("/logs");
			if (!response) {
				return;
			}

			setTotal(response.data.total);
			setWalletsBalance(response.data.walletsBalance);
		};

		GetCommonLogs();
	}, []);

	return (
		<StyledComponent>
			<div className="title">Поиск транзакций</div>
			<div className="search">
				<select
					value={selectInput}
					onChange={(e) => setSelectInput(e.target.value)}
				>
					<option value={"address"}>Адрес</option>
					<option value={"account"}>Аккаунт</option>
				</select>
				<input
					type="text"
					value={searchInput}
					onChange={(e) => setSearchInput(e.target.value)}
				/>
				<Button onClick={OnSearchHandler}>Найти</Button>
			</div>
			<WalletBalance balance={walletsBalance} />
			<TotalBalance balance={total} />
		</StyledComponent>
	);
};

const StyledComponent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	& .search {
		display: flex;
		gap: 0.5rem;
		& > input {
			flex-grow: 1;
		}
	}

	& .actionType {
		display: flex;
		gap: 1rem;

		& > a {
			flex-grow: 1;

			& > button {
				width: 100%;
			}
		}
	}

	& .title {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 1.5rem;
	}
`;
